
import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { User } from '../models/user.model';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-change-password-modal',
    templateUrl: './change-password-modal.component.html',
    standalone: true,
    imports: [CommonModule, FormsModule, NgbModule]
})
export class ChangePasswordModalComponent implements OnInit {

    @Input() user: User;
    
    public newPassword: string = '';
    public confirmPassword: string = '';
    public passwordError: string = '';
    public confirmPasswordError: string = '';

    constructor(
        public modal: NgbActiveModal
    ) { }

    ngOnInit(): void {
    }

    clearPasswordError() {
        this.passwordError = '';
        this.confirmPasswordError = '';
    }

    validatePassword(): boolean {
        let isValid = true;
        
        this.passwordError = '';
        this.confirmPasswordError = '';

        if (!this.newPassword) {
            this.passwordError = 'Password is required';
            isValid = false;
        } else if (this.newPassword.length < 6) {
            this.passwordError = 'Password must be at least 6 characters long';
            isValid = false;
        }

        if (!this.confirmPassword) {
            this.confirmPasswordError = 'Please confirm the password';
            isValid = false;
        } else if (this.newPassword !== this.confirmPassword) {
            this.confirmPasswordError = 'Passwords do not match';
            isValid = false;
        }

        return isValid;
    }

    save() {
        if (!this.validatePassword()) {
            return;
        }
        
        this.modal.close({
            email: this.user.email,
            newPassword: this.newPassword
        });
    }

    cancel() {
        this.modal.dismiss();
    }
}